// extracted by mini-css-extract-plugin
export var actionIcon = "_r8-0";